import { render } from "./SettingsB24.vue?vue&type=template&id=7f71d6c2"
import script from "./SettingsB24.vue?vue&type=script&lang=js"
export * from "./SettingsB24.vue?vue&type=script&lang=js"

import "./SettingsB24.vue?vue&type=style&index=0&id=7f71d6c2&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__